export default theme => ({
  alert: {
    background: theme.palette.secondary.main,
    "& *": {
      color: theme.palette.white.main,
      fontWeight: 500,
    },
    "&:hover *": {
      color: theme.palette.primary.main,
      fontWeight: "unset",
    },
  },
  alertText: {
    textTransform: "uppercase",
    fontSize: 15,
  },
  alertLink: {
    textDecoration: "underline !important",
  },
  title: {
    fontWeight: 500,
  },
  date: {
    fontWeight: "initial",
    fontSize: theme.textSizes[1],
  },
  date_container: {
    display: 'flex',
    gap: theme.spacing(12),
  },
  main: {
    background: theme.palette.blue.light,
    "& div, p, button": {
      color: theme.palette.blue.dark,
    },
  },
  titleRow: {
    height: 50,
    textAlign: "left",
    verticalAlign: "middle",
    display: "table-row",
    paddingLeft: 10,
    background: theme.palette.primary.main,
    color: theme.palette.white.main + ' !important',
    fontWeight: 700 + ' !important',
    "& th": {
      color: theme.palette.white.main,
      fontWeight: 700,
    },
    "&:hover th": {
      color: theme.palette.white.main,
      fontWeight: 700,
    },
  },
  titleTableContent: {
    background: theme.palette.primary.main,
    width: "100%",
    color: theme.palette.white.main + ' !important',
    fontWeight: 700 + ' !important',
    height: 50,
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    marginTop: "20px",
  },
  mainHeader: {
    fontSize: 20,
  },
  subtitleRow: {
    "& td": {
      fontWeight: 500,
    },
  },
  row: {
    "& td": {
      paddingLeft: 50,
    },
  },
  rowButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
});
